exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading-container[data-v-6caacad5]{padding:20px;text-align:center}.loading-text[data-v-6caacad5]{color:#666;font-size:14px}", "", {"version":3,"sources":["/workspace/src/views/payment-manager-new/pages/PaymentManagerDetailRedirect.vue"],"names":[],"mappings":"AACA,oCAAoC,aAAa,iBAAiB,CACjE,AACD,+BAA+B,WAAW,cAAc,CACvD","file":"PaymentManagerDetailRedirect.vue","sourcesContent":["\n.loading-container[data-v-6caacad5]{padding:20px;text-align:center\n}\n.loading-text[data-v-6caacad5]{color:#666;font-size:14px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6caacad5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/payment-manager-new/pages/PaymentManagerDetailRedirect.vue
// module id = 4956
// module chunks = 348